import type { FreightHazardClass, PackingGroup } from '../../../../types/ltl';

/**
 * DOT hazard class options shared with the product-details HazmatSection.
 * Keys are the DOT display codes (e.g. '3', '4.1', '2.3, 5.1, 8').
 * Composite keys (comma-separated) encode multiple hazard classes in priority order.
 * Use `dotKeyToHazardClasses` to convert to the backend `FreightHazardClass[]` format.
 */
export const HAZARD_CLASS_OPTIONS: { value: string; label: string }[] = [
  { value: '1.1A', label: '1.1A' },
  { value: '1.1A, 6.1', label: '1.1A, 6.1' },
  { value: '1.1B', label: '1.1B' },
  { value: '1.1C', label: '1.1C' },
  { value: '1.1D', label: '1.1D' },
  { value: '1.1D, 6.1', label: '1.1D, 6.1' },
  { value: '1.1E', label: '1.1E' },
  { value: '1.1F', label: '1.1F' },
  { value: '1.1G', label: '1.1G' },
  { value: '1.1J', label: '1.1J' },
  { value: '1.1L', label: '1.1L' },
  { value: '1.2B', label: '1.2B' },
  { value: '1.2C', label: '1.2C' },
  { value: '1.2D', label: '1.2D' },
  { value: '1.2E', label: '1.2E' },
  { value: '1.2F', label: '1.2F' },
  { value: '1.2G', label: '1.2G' },
  { value: '1.2G, 8, 6.1', label: '1.2G, 8, 6.1' },
  { value: '1.2H', label: '1.2H' },
  { value: '1.2J', label: '1.2J' },
  { value: '1.2K, 6.1', label: '1.2K, 6.1' },
  { value: '1.2L', label: '1.2L' },
  { value: '1.3C', label: '1.3C' },
  { value: '1.3C, 6.1', label: '1.3C, 6.1' },
  { value: '1.3G', label: '1.3G' },
  { value: '1.3G, 8, 6.1', label: '1.3G, 8, 6.1' },
  { value: '1.3H', label: '1.3H' },
  { value: '1.3J', label: '1.3J' },
  { value: '1.3K, 6.1', label: '1.3K, 6.1' },
  { value: '1.3L', label: '1.3L' },
  { value: '1.4B', label: '1.4B' },
  { value: '1.4C', label: '1.4C' },
  { value: '1.4D', label: '1.4D' },
  { value: '1.4E', label: '1.4E' },
  { value: '1.4F', label: '1.4F' },
  { value: '1.4G', label: '1.4G' },
  { value: '1.4G, 8, 6.1', label: '1.4G, 8, 6.1' },
  { value: '1.4S', label: '1.4S' },
  { value: '1.5D', label: '1.5D' },
  { value: '1.6N', label: '1.6N' },
  { value: '2.1', label: '2.1' },
  { value: '2.1, 6.1', label: '2.1, 6.1' },
  { value: '2.1, 8', label: '2.1, 8' },
  { value: '2.2', label: '2.2' },
  { value: '2.2, 5.1', label: '2.2, 5.1' },
  { value: '2.2, 6.1', label: '2.2, 6.1' },
  { value: '2.2, 8', label: '2.2, 8' },
  { value: '2.3', label: '2.3' },
  { value: '2.3, 2.1', label: '2.3, 2.1' },
  { value: '2.3, 2.1, 8', label: '2.3, 2.1, 8' },
  { value: '2.3, 5.1', label: '2.3, 5.1' },
  { value: '2.3, 5.1, 8', label: '2.3, 5.1, 8' },
  { value: '2.3, 8', label: '2.3, 8' },
  { value: '2.3, 8, 5.1', label: '2.3, 8, 5.1' },
  { value: '3', label: '3' },
  { value: '3, 6.1', label: '3, 6.1' },
  { value: '3, 6.1, 8', label: '3, 6.1, 8' },
  { value: '3, 8', label: '3, 8' },
  { value: '4.1', label: '4.1' },
  { value: '4.1, 5.1', label: '4.1, 5.1' },
  { value: '4.1, 6.1', label: '4.1, 6.1' },
  { value: '4.1, 8', label: '4.1, 8' },
  { value: '4.2', label: '4.2' },
  { value: '4.2, 4.3', label: '4.2, 4.3' },
  { value: '4.2, 5.1', label: '4.2, 5.1' },
  { value: '4.2, 6.1', label: '4.2, 6.1' },
  { value: '4.2, 8', label: '4.2, 8' },
  { value: '4.3', label: '4.3' },
  { value: '4.3, 3', label: '4.3, 3' },
  { value: '4.3, 3, 8', label: '4.3, 3, 8' },
  { value: '4.3, 4.1', label: '4.3, 4.1' },
  { value: '4.3, 4.2', label: '4.3, 4.2' },
  { value: '4.3, 5.1', label: '4.3, 5.1' },
  { value: '4.3, 6.1', label: '4.3, 6.1' },
  { value: '4.3, 8', label: '4.3, 8' },
  { value: '4.3, 8, 3', label: '4.3, 8, 3' },
  { value: '5.1', label: '5.1' },
  { value: '5.1, 4.1', label: '5.1, 4.1' },
  { value: '5.1, 4.2', label: '5.1, 4.2' },
  { value: '5.1, 4.3', label: '5.1, 4.3' },
  { value: '5.1, 6.1', label: '5.1, 6.1' },
  { value: '5.1, 6.1, 8', label: '5.1, 6.1, 8' },
  { value: '5.1, 8', label: '5.1, 8' },
  { value: '5.2', label: '5.2' },
  { value: '5.2, 1', label: '5.2, 1' },
  { value: '6.1', label: '6.1' },
  { value: '6.1, 3', label: '6.1, 3' },
  { value: '6.1, 3, 8', label: '6.1, 3, 8' },
  { value: '6.1, 4.1', label: '6.1, 4.1' },
  { value: '6.1, 4.2', label: '6.1, 4.2' },
  { value: '6.1, 4.3', label: '6.1, 4.3' },
  { value: '6.1, 4.3, 3', label: '6.1, 4.3, 3' },
  { value: '6.1, 5.1', label: '6.1, 5.1' },
  { value: '6.1, 7, 8', label: '6.1, 7, 8' },
  { value: '6.1, 8', label: '6.1, 8' },
  { value: '6.1, 8, 3', label: '6.1, 8, 3' },
  { value: '6.2', label: '6.2' },
  { value: '7', label: '7' },
  { value: '7, 6.1, 8', label: '7, 6.1, 8' },
  { value: '8', label: '8' },
  { value: '8, 3', label: '8, 3' },
  { value: '8, 3, 6.1', label: '8, 3, 6.1' },
  { value: '8, 4.1', label: '8, 4.1' },
  { value: '8, 4.2', label: '8, 4.2' },
  { value: '8, 4.3', label: '8, 4.3' },
  { value: '8, 5.1', label: '8, 5.1' },
  { value: '8, 5.1, 6.1', label: '8, 5.1, 6.1' },
  { value: '8, 6.1', label: '8, 6.1' },
  { value: '8, 6.1, 3', label: '8, 6.1, 3' },
  { value: '9', label: '9' },
];

/**
 * Packing group options. Values match the backend `PackingGroup` enum directly.
 */
export const PACKING_GROUP_OPTIONS: { value: PackingGroup; label: string }[] = [
  { value: 'PGI', label: 'I' },
  { value: 'PGII', label: 'II' },
  { value: 'PGIII', label: 'III' },
  { value: 'NoPackagingGroup', label: 'No Packaging Group' },
];

/**
 * Converts a single DOT hazard code part (e.g. '3', '4.1', '1.1A') to the
 * backend `FreightHazardClass` enum name (e.g. 'Class3', 'Class4_1', 'Class1_1A').
 */
const dotCodeToHazardClassEnum = (dotCode: string): FreightHazardClass =>
  `Class${dotCode.trim().replace(/\./g, '_')}` as FreightHazardClass;

/**
 * Converts a DOT composite key from `HAZARD_CLASS_OPTIONS` (e.g. '2.3, 5.1, 8')
 * to a `FreightHazardClass[]` array in the same order (e.g. ['Class2_3', 'Class5_1', 'Class8']).
 * Returns `null` when the input is empty.
 */
export const dotKeyToHazardClasses = (dotKey: string | null): FreightHazardClass[] | null => {
  if (!dotKey) return null;
  return dotKey.split(',').map(dotCodeToHazardClassEnum);
};

/**
 * Converts a `FreightHazardClass[]` array back to a DOT composite key for the dropdown.
 * e.g. ['Class2_3', 'Class5_1', 'Class8'] → '2.3, 5.1, 8'.
 * Returns `null` when the array is empty or null.
 */
export const hazardClassesToDotKey = (classes: FreightHazardClass[] | null | undefined): string | null => {
  if (!classes?.length) return null;
  return classes.map((c) => c.replace(/^Class/, '').replace(/_/g, '.')).join(', ');
};
